import { noop } from "@jetjs/utils";
import { SubscriptionImpl } from "./Subscription";
import { SubscriptionObserverImpl } from "./SubscriptionObserver";
/**
 * Observables are always Hot-Observables and are lazy by default
 *
 * @param T - type from the value passed to the stream via #next
 *
 * @public
 */
export class Observable {
    constructor(producer) {
        this.producer = producer;
    }
    /**
     * Creates a sync stream with the provided values.
     *
     * @param values - parameter list with values to create a stream from.
     */
    // tslint:disable-next-line no-reserved-keywords
    static of(...values) {
        return new Observable((so) => {
            values.forEach(v => so.next(v));
            so.complete();
            so.unsubscribe();
            return noop;
        });
    }
    /**
     * subscribe to the observable and start the lazy stream
     *
     * @param observerOrNext - If an Observer is provided, the following arguments will be ignored
     * @param error - (otpional) Error handler
     * @param complete - (optional) completion handler
     */
    subscribe(observerOrNext, error, complete) {
        if (this.nextObserver) {
            throw new Error("Observable already has an observer.");
        }
        this.nextObserver = this.toObserver(observerOrNext, error, complete);
        this.subscription = new SubscriptionImpl(() => this.cancel());
        // start the subscription and producer and save cancelFn for later termination
        this.nextObserver.start(this.subscription);
        this.producerCancelFn = this.producer(new SubscriptionObserverImpl(this.nextObserver, this.subscription));
        return this.subscription;
    }
    /**
     * adds a new Operator to the stream. It doesn't starts the lazy stream.
     *
     * @param operator - the ObservableObserver to add
     * @param O - the value type passed to the stream from the given operator
     */
    pipe(operator) {
        operator.addObservable(this);
        return operator;
    }
    /**
     * stops the producer
     */
    cancel() {
        if (this.producerCancelFn) {
            this.producerCancelFn();
        }
    }
    toObserver(observerOrNext, error, complete) {
        if (!(typeof observerOrNext === "function")) {
            return observerOrNext;
        }
        // create minimal observer from the provided methods.
        return {
            start: noop,
            next: observerOrNext,
            error: error || noop,
            complete: complete || noop
        };
    }
}
//# sourceMappingURL=Observable.js.map